import React, { useEffect, useContext } from 'react';

import { ContentCard } from '@rockerbox/styleguide';
import { Header, Loader, Popup, Icon } from 'semantic-ui-react';

import BarChart from './BarChart';
import { useModelRuns, useModelsData, useChartData } from './hooks';
import { track } from '../../../utils/tracking';
import { ViewAccessWrapper, BasicViewHeader, StyledDropdown } from '../../components';
import { MARKETING_MIX_MODELING } from '../../constants/views';
import { FeatureAliasesContext, FeatureAliasesProvider } from '../../context/MMMFeatureAliases';

const ModelComparison = () => {
  const { modelRuns, kpiType, setKpiType, kpiTypeOptions, execDtNameMap } = useModelRuns();

  const { data } = useModelsData(modelRuns, kpiType);
  const { featureAliasesMap } = useContext(FeatureAliasesContext);
  const { loading, chartData, execDtsColors } = useChartData(data, featureAliasesMap);

  useEffect(() => {
    track('mmm.model_comparison.view');
  }, []);

  return (
    <>
      <BasicViewHeader
        header="Model Comparison"
        subheader="Compare performance results between different models"
      />
      <ContentCard
        title={!loading && (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Header
                as="h2"
                content={`${kpiType === 'conversions' ? 'CPA' : 'ROI'} By Channel By Model`}
              />
              <Popup
                trigger={<Icon name="info circle" color="purple" />}
                content="Maximum of 4 models can be compared at once."
                position="top center"
              />
            </div>
            {kpiTypeOptions.length > 1 && (
              <StyledDropdown
                selection
                value={kpiType}
                options={kpiTypeOptions}
                onChange={(_, { value }) => setKpiType(value)}
              />
            )}
          </div>
        )}
      >
        {loading ? (
          <div style={{ height: 200 }}>
            <Loader active />
          </div>
        ) : (
          <BarChart
            data={chartData}
            colorMap={execDtsColors}
            dataKey="name"
            kpiType={kpiType}
            execDtNameMap={execDtNameMap}
          />
        )}
      </ContentCard>
    </>
  );
};

const ModelComparisonAccess = () => (
  <FeatureAliasesProvider>
    <ViewAccessWrapper
      viewName={MARKETING_MIX_MODELING}
      viewComponent={<ModelComparison />}
    />
  </FeatureAliasesProvider>
);

export default ModelComparisonAccess;
